import type { MetaFunction } from "@remix-run/node";
import { useEffect, useState, useRef } from "react";
import { Link } from "@remix-run/react";
import { ArrowUpIcon } from '@heroicons/react/24/outline';

export const meta: MetaFunction = ({ data, params }: { data: any, params: any }) => {
  const title = `Readme Badge - Related Repos`;
  const description = 'Add the Official Badge to Your GitHub repository README';
  const canonicalURL = `${__BASE_URL__}/badge`;
  const jsonLD = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": canonicalURL
  };

  return [
    { title },
    { name: "description", content: description },
    { tagName: "link", rel: "canonical", href: canonicalURL },
    { "script:ld+json": jsonLD },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonicalURL },
    { property: "og:image", content: __OG_IMAGE__ }
  ];
};

export default function Index() {
  const markdownSource = "[![RelatedRepos](https://img.shields.io/badge/related-repos-yellow)](https://relatedrepos.com/gh/<owner>/<repo>)";

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(markdownSource);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div className="background-gray px-2 py-2 border border-gray-100 rounded-md">
        <div className="flex items-center py-1">
          <h1 className="text-xl font-bold mr-1 ">
            Repository README Badge
          </h1>
        </div>
      </div>

      <div className="max-w-prose mx-auto pb-10 ">
        <p className="mt-4 mb-5 text-xl text-center">
          Add the Official Badge to Your GitHub repository README
        </p>

        <p className="mt-4 mb-2 text-lg text-center">
          Preview:
        </p>

        <p className="flex items-center justify-center w-full mb-4">
          <a href="https://relatedrepos.com/gh/airbnb/javascript">
            <img src="https://img.shields.io/badge/related-repos-yellow" />
          </a>
        </p>

        <p className="py-2">Add a "Related Repos" badge to your README to help your users discover similar projects.</p>

        <p className="py-3">Copy the Markdown snippet below and replace &lt;owner&gt; and &lt;repo&gt; with your GitHub username and repository name:</p>

        <div className="flex flex-col items-center">
          <div className="w-full relative">
            <button
              onClick={handleCopy}
              className="absolute top-2 right-2 px-2 py-1 text-xs background-button-white ring-1 ring-inset ring-gray-300 rounded-md transition-colors"
            >
              {copied ? "✓ Copied!" : "Copy"}
            </button>
            <pre className="max-w-full overflow-auto [scrollbar-width:thin] p-2 text-sm background-button-white ring-1 ring-inset ring-gray-300 rounded-md">
              <code>
                {markdownSource}
              </code>
            </pre>
          </div>
        </div>

        <p className="py-4 mt-5">
          Example: For the repo <code className="ring-1 ring-inset ring-gray-300 rounded-md p-1 text-sm">github.com/octocat/hello-world</code>:
        </p>

        <div className="flex flex-col items-center">
          <div className="w-full max-w-3xl">
            <pre className="max-w-full overflow-auto [scrollbar-width:thin] p-2 text-sm background-button-white ring-1 ring-inset ring-gray-300 rounded-md">
              <code>
                [![RelatedRepos](https://img.shields.io/badge/related-repos-yellow)](https://relatedrepos.com/gh/octocat/hello-world)
              </code>
            </pre>
          </div>
        </div>

      </div>
    </>
  );
}
